const sitemap = (state) => state;

const geo = (state) => state.geo;

export default {
    geo,
    sitemap,
};
